import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3db9e744"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sf-accordion", _ctx.visibleClass]),
    style: _normalizeStyle({ height: _ctx.bodyHeight }),
    onTransitionend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onTranstionEnd && _ctx.onTranstionEnd(...args)))
  }, [
    _createElementVNode("div", {
      ref: "accordionBody",
      class: _normalizeClass(_ctx.dummyClass)
    }, [
      (_ctx.isActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default", {
              onResized: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshHeight && _ctx.refreshHeight(...args)))
            }, undefined, true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 38))
}